import { pick } from "underscore";

import * as apiFactory from "./ApiFactory";

import type { SummaryNote } from "@/models/SummaryNote";

export async function load(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
): Promise<SummaryNote[]> {
  const client = await apiFactory.WithBearer();

  return await client.get<SummaryNote[]>(["/api/summaryNotes", clientName, brand, caseReference, fileReference]);
}

export async function save(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  summaryNote: Pick<SummaryNote, "reference" | "summaryText" | "evidenceTheme" | "position" | "confidence">,
): Promise<void> {
  const client = await apiFactory.WithBearer();

  await client.post(["/api/summaryNotes", clientName, brand, caseReference, fileReference], summaryNote);
}

export async function update(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  reference: string,
  summaryNote: Pick<SummaryNote, "summaryText" | "position">,
): Promise<void> {
  const client = await apiFactory.WithBearer();

  await client.put(
    ["/api/summaryNotes", clientName, brand, caseReference, fileReference, reference],
    pick(summaryNote, ["summaryText", "position"]),
  );
}

export async function deleteSummaryNote(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  reference: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();

  await client.delete(["/api/summaryNotes", clientName, brand, caseReference, fileReference, reference]);
}

export async function get<SummaryNoteType = SummaryNote>(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  reference: string,
): Promise<SummaryNoteType> {
  const client = await apiFactory.WithBearer();

  return await client.get<SummaryNoteType>([
    "/api/summaryNotes",
    clientName,
    brand,
    caseReference,
    fileReference,
    reference,
  ]);
}

export async function exportNotes(clientName: string, brand: string, caseReference: string, fileReference: string) {
  const client = await apiFactory.WithBearer();

  return await client.put(["/api/RecordAction/export-meetingnotes", clientName, brand, caseReference, fileReference]);
}
